import { AppSyncFarmToken } from 'common/models/farm';
import { Nullable } from 'common/models/optional';
import React from 'react';
import Select, { components } from 'react-select';
import { TokenIcon, TokenName } from '../TokenIcons/TokenIcon';
import { StyledMintOption, StyledSelectToken } from './selectToken.style';

type Props = {
  name: string;
  values: AppSyncFarmToken[];
  isLoading: boolean;
  isCollateral?: boolean;
  value?: Nullable<AppSyncFarmToken>;
  onChange: (value: AppSyncFarmToken) => void;
  id?: string;
  label?: string;
  labelClass?: string;
  isClearable?: boolean;
};

const SelectVaultToken: React.FC<Props> = (props) => {
  type RenderStyledMintOptionArgs = {
    data: AppSyncFarmToken;
  };
  const RenderStyledMintOption = (args: RenderStyledMintOptionArgs) => {
    const name = args.data.displayName;
    const symbol = args.data.name;
    return (
      <StyledMintOption>
        <TokenIcon name={symbol as TokenName} height="10px" />
        <span className="black">{name === 'ETHC' ? 'ETH' : name}</span>
      </StyledMintOption>
    );
  };

  const TokenOption = (innerProps) => {
    return (
      <components.Option {...innerProps}>
        <RenderStyledMintOption {...innerProps} />
      </components.Option>
    );
  };

  const TokenSingleValue = (innerProps) => {
    return (
      <components.SingleValue {...innerProps}>
        <RenderStyledMintOption {...innerProps} />
      </components.SingleValue>
    );
  };

  const onChange = (c: Nullable<AppSyncFarmToken>) => {
    props.onChange(c as AppSyncFarmToken);
  };

  const getName = (c: AppSyncFarmToken) => {
    return c.displayName === 'ETHC' ? 'ETH' : c.displayName;
  };

  const getSymbol = (c: AppSyncFarmToken) => {
    return c.displayName;
  };

  return (
    <StyledSelectToken className="styled-select-token" id={props.id}>
      {props.label && (
        <div
          className={`text-left pl-2 tablet:pl-5 pb-[10px] ${props.labelClass}`}
        >
          {props.label}
        </div>
      )}
      <Select<AppSyncFarmToken>
        className="basic-single"
        classNamePrefix="vault-select"
        defaultValue={props.value}
        value={props.value}
        getOptionLabel={getName}
        getOptionValue={getSymbol}
        isDisabled={props.isLoading}
        isLoading={props.isLoading}
        name={props.name}
        isClearable={props.isClearable}
        options={props.values}
        components={{
          Option: TokenOption,
          SingleValue: TokenSingleValue,
        }}
        onChange={onChange}
      />
    </StyledSelectToken>
  );
};

export default SelectVaultToken;
